<div class="sidebar-fixed">
  <div *ngIf="currentUser$ | async">
    <anms-user-card [currentUser]="currentUser$ | async"></anms-user-card>
  </div>
  <div class="sidebar-sticky-0">
    <mat-card class="mb-3 p-0">
      <div class="box-title border-bottom p-3 mb-2">
        <h6 class="m-0 text-success font-weight-bold"><i class="fas fa-hashtag"></i> Trending</h6>
      </div>
      <div class="px-2">
        <anms-trends></anms-trends>
        &nbsp;
      </div>
      <div class="border-top p-2 vm-trends">
        <a routerLink="/trends">
          <h6 class="text-center text-success">View More</h6>
        </a>
      </div>
    </mat-card>
    <!-- <anms-weather></anms-weather> -->
    <anms-suggested-users *ngIf="isAuthenticated$ | async"></anms-suggested-users>
  </div>
</div>